import type { FunctionComponent } from 'react'
import { GridItem, TypographyV2 as Typography } from '@which/seatbelt'

import classnames from 'classnames'

import type {
  VerticalAboutWhichPageQuery,
  VerticalPensionSchemePageQuery,
} from '../../../../generated/frontend'
import { Link } from '../../../../shared/components/Link/index'
import styles from './VerticalNavigation.module.scss'

type Props = {
  data:
    | VerticalAboutWhichPageQuery['verticalPage']['aboutWhich']
    | VerticalPensionSchemePageQuery['verticalPage']['pensionScheme']
  type: 'articles' | 'widgets'
}

export const VerticalNavigation: FunctionComponent<Props> = ({ data, type }) => {
  if (!data || !type) {
    return null
  }

  switch (type) {
    case 'articles':
      return renderArticlesComponent(data)
    case 'widgets':
      return renderWidgetsComponent(data)
  }
}

///////// IMPLEMENTATION /////////

const renderArticlesComponent = (
  data:
    | VerticalAboutWhichPageQuery['verticalPage']['aboutWhich']
    | VerticalPensionSchemePageQuery['verticalPage']['pensionScheme']
) => (
  <div
    data-testid="articles-navigation"
    className={classnames(styles.awNavWrapper, {
      [styles.awNavWrapperEvenGridItems]: data.subVerticalArticles.length % 2 === 0,
    })}
  >
    {data.subVerticalArticles.map((element, index) => (
      <GridItem
        key={`article${index}`}
        span={{ medium: 8, large: 6 }}
        columnStart={{
          medium: 1,
          large: (index + 1) % 2 === 0 ? 7 : 1,
        }}
        className={styles.navGridItem}
      >
        <Link className={styles.awArticleLink} textStyle="sb-text-heading-small" href={element.url}>
          {element.title}
        </Link>
        <Typography textStyle="sb-text-body-default-regular">{element.description}</Typography>
      </GridItem>
    ))}
  </div>
)

const renderWidgetsComponent = (
  data:
    | VerticalAboutWhichPageQuery['verticalPage']['aboutWhich']
    | VerticalPensionSchemePageQuery['verticalPage']['pensionScheme']
) => (
  <div data-testid="widgets-navigation" className={styles.awPromoWrapper}>
    {data.promoUrls.map((element, index) => (
      <GridItem
        key={'widget' + index}
        span={{ medium: 5, large: 5 }}
        columnStart={{
          medium: (index + 1) % 2 === 0 ? 7 : 2,
          large: (index + 1) % 2 === 0 ? 7 : 2,
        }}
        className={styles.navGridItem}
      >
        <div>
          <Link
            className={styles.awArticleLink}
            appearance="secondary"
            includeIcon={true}
            href={element.url}
          >
            {element.title}
          </Link>
          <Typography textStyle="sb-text-body-default-regular" className={styles.widgetsStandfirst}>
            {element.description}
          </Typography>
        </div>
      </GridItem>
    ))}
  </div>
)
